import { render, staticRenderFns } from "./usedcarfooter.vue?vue&type=template&id=5d5ece0b&"
import script from "./usedcarfooter.vue?vue&type=script&lang=js&"
export * from "./usedcarfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports